import React from 'react';

const ProfileCard = ({
    profile,
    onEdit,
    onPreview,
    onDelete,
    onSetDefault,
    onGenerateTheme
}) => {
    return (
        <div className={`profile-card ${profile.is_default ? 'default-profile' : ''}`}>
            {profile.is_default && (
                <div className="default-badge">
                    ⭐ Default
                </div>
            )}

            <div className="profile-header">
                <h3>{profile.business_name}</h3>
                {profile.tagline && (
                    <p className="tagline">{profile.tagline}</p>
                )}
            </div>

            <div className="profile-meta">
                <div className="meta-item">
                    <span className="icon">📧</span>
                    <span>{profile.email}</span>
                </div>
                {profile.phone && (
                    <div className="meta-item">
                        <span className="icon">📞</span>
                        <span>{profile.phone}</span>
                    </div>
                )}
                <div className="meta-item">
                    <span className="icon">🎯</span>
                    <span>{profile.service_count || 0} services</span>
                </div>
                {profile.industry && (
                    <div className="meta-item">
                        <span className="icon">🏢</span>
                        <span>{profile.industry}</span>
                    </div>
                )}
            </div>

            <div className="profile-footer">
                <div className="created-date">
                    Created: {new Date(profile.created_at).toLocaleDateString()}
                </div>

                <div className="action-buttons">
                    <button
                        className="btn-icon"
                        onClick={() => onEdit(profile.id)}
                        title="Edit Profile"
                    >
                        ✏️
                    </button>
                    <button
                        className="btn-icon"
                        onClick={() => onPreview(profile)}
                        title="Preview"
                    >
                        👁️
                    </button>
                    <button
                        className="btn-icon"
                        onClick={() => onDelete(profile.id)}
                        title="Delete"
                    >
                        🗑️
                    </button>
                    {!profile.is_default && (
                        <button
                            className="btn-icon"
                            onClick={() => onSetDefault(profile.id)}
                            title="Set as Default"
                        >
                            ⭐
                        </button>
                    )}
                </div>

                <button
                    className="btn-generate"
                    onClick={() => onGenerateTheme(profile)}
                >
                    Generate Theme with This Profile
                </button>
            </div>
        </div>
    );
};

export default ProfileCard;
